/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Merch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Merch"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4BA279"
        d="M15.783 8.627a1 1 0 0 1 1.249-.672l3.23.979a1 1 0 0 1 .668 1.242l-1.906 6.418a6.3 6.3 0 0 1-3.674 4.057l-2.873 1.16a2.676 2.676 0 0 1-3.49-1.51c-.55-1.391.12-2.97 1.496-3.527l2.872-1.16a.9.9 0 0 0 .526-.58zM9.988 2.722a1 1 0 0 1 1.248-.672l3.23.978a1 1 0 0 1 .67 1.242l-1.907 6.418a6.3 6.3 0 0 1-3.675 4.058l-2.872 1.16a2.676 2.676 0 0 1-3.49-1.51c-.55-1.391.118-2.97 1.495-3.527L7.56 9.71a.9.9 0 0 0 .525-.58z"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="m20.317 12.245-.48 1.616-5.14-1.572.479-1.615zm.682-2.322a1 1 0 0 1-.025.111l-.447 1.506-5.141-1.571.445-1.501a1 1 0 0 1 .042-.111zM14.53 6.31l-.479 1.615-5.14-1.571.479-1.615zm.678-2.323a1 1 0 0 1-.029.141l-.439 1.477L9.6 4.033l.436-1.471a1 1 0 0 1 .056-.14z"
        className="Details"
      />
    </g>
  </svg>
);

export const MerchIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'merch-icon'}
      icon={Merch}
      {...props}
      size={size}
    />
  );
};
